const TDS_DOCUMENT_LABELS: Record<string, string> = {
    FORM131: 'Form 131',
    FORM16A: 'Form 16A',
};

export const getTdsDocumentLabel = ({documentName, formType}: {documentName: string; formType?: string}): string => {
    const key = formType?.trim() ? formType : documentName;
    return TDS_DOCUMENT_LABELS[key] ?? key;
};
